import * as angular from "angular";

angular
  .module('triangular')
  .provider('triSettings', settingsProvider);

function settingsProvider(): any {
  // Provider
  let settings: any = {
    languages: []
  };

  this.addLanguage = addLanguage;

  function addLanguage(newLanguage) {
    settings.languages.push(newLanguage);
  }

  // Service
  this.$get = function () {
    return {
      languages: settings.languages,
      name: settings.name,
      copyright: settings.copyright,
      logo: settings.logo,
      version: settings.version,
      defaultSkin: settings.defaultSkin
    };
  };
}
